import { createContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../redux/actions/loadingActions/loadingActions";
import { setAuthAction } from "./../../redux/actions/authActions/authActions";
import {
  forgetPassAuthService,
  logInAuthService,
  registerAuthService,
} from "../../services/userServices";
import {
  deliverySuccessMessage,
  toastErrorMessage,
} from "../../utils/toastMessage/toastMessage";

export const authContext = createContext({
  handleRegister: () => {},
  handleLogIn: () => {},
  handleForgetPassword: () => {},
});

const AuthContext = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Save Token
  const saveToken = (data) => {
    dispatch(setAuthAction(data.result?.accessToken));
    window.location.reload();
  };

  // Register
  const handleRegister = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await registerAuthService(userData);
      if (status === 200) {
        navigate("/auth/login");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Log In
  const handleLogIn = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { data, status } = await logInAuthService(userData);
      if (status === 200) {
        saveToken(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Forget Password
  const handleForgetPassword = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { data, status } = await forgetPassAuthService(userData);
      if (status === 200) {
        deliverySuccessMessage(data.resultMessage, "/auth/login", "3000");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <authContext.Provider
      value={{
        handleRegister,
        handleLogIn,
        handleForgetPassword,
      }}
    >
      {children}
    </authContext.Provider>
  );
};

export default AuthContext;
